// @ts-strict-ignore
import { ForgotPassword } from 'components/ForgotPassword'
import withPreloadedQuery from 'withPreloadedQuery'
import { serverSidePostQueryAuth } from 'services/auth'
import { ForgotPasswordQuery, isAllowed } from 'components/ForgotPassword/ForgotPassword'
import { ForgotPassword_Query } from '__generated__/ForgotPassword_Query.graphql'

// TODO: authentication
export default withPreloadedQuery(ForgotPassword, ForgotPasswordQuery, {
  serverSidePostQuery: serverSidePostQueryAuth<ForgotPassword_Query>(queryResult => isAllowed(queryResult?.data?.currentUser)),
})
